<template>
  <v-container fluid class="grey lighten-5 px-2 pb-0">
    <v-row dense class="pa-3">
      <v-col dense cols="4" class="pa-0">
        <div class="display-1" id="title">
          スタッフＴＯＰ
        </div>
      </v-col>
    </v-row>

    <v-card v-if="isErrorParam" flat outlined class="ma-5 pa-3">
      <div class="subtitle-2 mb-2">
        <v-icon class="mr-1" color="primary" small>mdi-information-outline</v-icon>
        <span class="primary--text">アクセスできません</span>
      </div>
      <v-btn icon :to="{ path: '/' }">
        <v-icon>mdi-arrow-left</v-icon>
      </v-btn>お申込みページに戻る
    </v-card>

    <v-form v-if="!isErrorParam" ref="staffpage_form">
    <v-row dense>

      <v-col cols="3">
        <div class="px-3">
          <v-select
            v-model="type"
            :items="types"
            item-text="text"
            item-value="type"
            label="種別で絞り込み"
          ></v-select>
        </div>
      </v-col>

      <v-col cols="3">
        <v-menu
          v-model="isOpenCreateAt"
          :close-on-content-click="false"
          :nudge-right="40"
          transition="scale-transition"
          offset-y
          min-width="290px"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-model="createAt"
              prepend-inner-icon="mdi-magnify"
              label="お申込み日で絞り込み"
              v-bind="attrs"
              v-on="on"
              clearable
            ></v-text-field>
          </template>
          <v-date-picker
            v-model="createAt"
            @input="menu3=false"
            locale="ja"
          ></v-date-picker>
        </v-menu>
      </v-col>

      <v-col cols="3">
        <div class="px-3">
          <v-text-field
            v-model="search"
            prepend-inner-icon="mdi-magnify"
            label="予約番号で絞り込み"
          ></v-text-field>
        </div>
      </v-col>


<!--
      <v-col cols="12">
        <v-radio-group row v-model="filteredApplicationType" class="ml-md-8 ml-2 mt-0" dense>
          <v-radio value="all">
            <template v-slot:label>
              <div>すべて</div>
            </template>
          </v-radio>
          <v-radio value="Quote">
            <template v-slot:label>
              <div>お見積り</div>
            </template>
          </v-radio>
          <v-radio value="Application">
            <template v-slot:label>
              <div>分析依頼</div>
            </template>
          </v-radio>
        </v-radio-group>
      </v-col>
-->
      <v-col cols="12" lg="12" md="12" sm="12" xs="12" dense>
        <v-data-table
          :headers="applicationListheaders"
          :items="applications"
          :page.sync="page"
          :items-per-page="itemsPerPage"
          :sort-by="['createdAt']"
          :sort-desc="[true]"
          :loading="loading"
          class="elevation-1 px-3"
          loading-text="読込中"
          no-data-text="データがありません。"          
          no-results-text="検索条件に該当するデータがありません。"                  
          hide-default-footer
          @page-count="pageCount = $event"
          @click:row="selectApplication"
          id="row-pointer"
          :fixed-header=true
          
        >
<!--
          @click:row="(data) => { $router.push(`/referapplication?id=${data.id}`) }"
-->
          <template v-slot:[`item.Type`]="{ item }">
            <v-chip small :color="item.Type=='Quote' ? 'amber darken-3' : 'green darken-1'" class="white--text">
              <span v-if="item.Type=='Quote'">お見積り依頼</span>
              <span v-else-if="item.Type=='Application'">分析依頼</span>
              <span v-else>分析依頼</span>
            </v-chip>
          </template>
          <template v-slot:[`item.createdAt`]="{ item }">
            <span> {{ item.createdAt | moment('YYYY[年]MM[月]DD[日] HH[時]mm[分]') }} </span>
          </template>
          <template v-slot:[`item.OrderNumber`]="{ item }">
            <span v-if="item.OrderNumber">{{ item.OrderNumber }}</span>
            <span v-else-if="!item.OrderNumber && item.Type=='Application'">採番待ち</span>
            <span v-else>－</span>
          </template>
          <template v-slot:[`item.SampleCount`]="{ item }">
            <div class="text-center"> {{ item.SampleCount }} </div>
          </template>
          <template v-slot:[`item.Status`]="{ item }">
            <v-chip small v-bind="getApplicationStatus(item.Status, 2)">{{getApplicationStatus(item.Status, 2).text}}</v-chip>
          </template>
          <template v-slot:[`item.OrdererCompanyName`]="{ item }">
            {{item.OrdererCompanyName}} {{item.OrdererOfficeName}}
          </template>


          </v-data-table>
      </v-col>
    </v-row>
    <v-row justify="center" dense>
      <v-col cols="10" lg="10" md='10' sm='10' xs="10">
        <v-pagination
         v-model="page"
         :total-visible="totalVisible"
         :length="pageCount"
         color="amber darken-1 black--text"
        light 
        circle>
        </v-pagination>
      </v-col>
      <v-col cols="4" lg="2"  md='4' sm='4' xs="6">
        <v-select
          :value="itemsPerPage"
          :items = "itemsPerPageList"
          label="1ページの行数"
          @input="itemsPerPage = $event"
        ></v-select>
      </v-col>
    </v-row>
    </v-form>

  <loading-dialog :message="loadingMessage" :progressMessages="progressMessages" ref="isLoading"></loading-dialog>

  </v-container>
</template>

<script>
import { API, graphqlOperation} from "aws-amplify"
import { sortedlistApplications } from '../graphql/queries'
import { officeByKey, } from '../graphql/queries'
import { companyByKey, } from '../graphql/queries'
import utils  from '../utils/utils.js'
import initcore  from '../utils/initialize.js'
import Loading from "../components/Loading.vue"

export default {
  name: 'StaffPage',
  mixins:[utils, initcore],
  components:{
    LoadingDialog: Loading,
  },
  head: {
    title: { inner: 'スタッフ向けTOP'},
  },
  data() {
    return {
      applicationListheaders: [
        {
          text: '種別',
          value: 'Type',
          class: "grey darken-2 white--text",
          filter: this.typeFilter,
          width: "10%",
        },
        {
          text: 'ご予約番号',
          value: 'id',
          class: "grey darken-2 white--text",
          filter: this.idFilter,
          width: "13%",
        },
        {
          text: '申込み日',
          value: 'createdAt',
          class: "grey darken-2 white--text",
          filter: this.createAtFilter,
          width: "17%",
        },
        {
          text: '得意先名',
          value: 'OrdererCompanyName',
          class: "grey darken-2 white--text",
          width: '25%',
        },
        {
          text: '注文番号',
          value: 'CustomerOrderNumber',
          class: "grey darken-2 white--text",
          width: '5%'
        },
        {
          text: 'サンプル数',
          value: 'SampleCount',
          class: "grey darken-2 white--text",
          align: 'center',
          width: '10%'
        },
        {
          text: 'ご予約状況',
          value: 'Status',
          class: "grey darken-2 white--text",
          width: '10%'
        },
        {
          text: '受注番号',
          value: 'OrderNumber',
          class: "grey darken-2 white--text",
          width: '10%'
        },
      ],
      applications: [],
      page: 1,
      pageCount: 0,
      itemsPerPage: 50,
      itemsPerPageList: [ 50,100, ],
      totalVisible: 7,
      search: '',
      createAt: '',
      type: 'all',
      types: [
        { type: "all", text: 'すべて' },
        { type: "Application", text: '分析依頼' },
        { type: "Quote", text: 'お見積り依頼' },
      ],
      isOpenCreateAt: false,
      loading: false, 
      filteredApplicationType: "all",

      isErrorParam: false,
      ErrorInfo: "",

      loadingMessage: "処理中です。しばらくこのままでお待ちください。",
      progressMessages: [{"status":0, "message":"事業所の切り替え"}],

    }
  },
  mounted: async function () {
    if(this.$store.state.isStaff == false) {
      this.isErrorParam = true
      this.ErrorInfo = "illegalAccess"
      this.loading = false
      console.log('isErrorParam: ', this.isErrorParam)
      return
    }
    this.filteredApplicationType = "all"
    this.getApplifation()
  },
  computed : {
  },
  methods: {
    idFilter(value){
      if (!this.search) {
        return true
      }
      return value.toLowerCase().includes(this.search.toLowerCase());
    },
    createAtFilter(value){
      if (!this.createAt) {
        return true
      }
      return value.toLowerCase().includes(this.createAt.toLowerCase());
    },
    typeFilter(value){
      if(this.type == "all"){
        return true
      }else if(this.type == "Application"){
        if(value == null) {
          return true
        }else {
          return value.toLowerCase().includes(this.type.toLowerCase());
        }
      }else{
        if(value == null) {
          return false
        }else {
          return value.toLowerCase().includes(this.type.toLowerCase());
        }
      }
    },
    getApplifation: async function() {
      this.loading = true

      // ApplicationとQuoteの両方を取得
      const [appResult, quoteResult] = await Promise.all([
        API.graphql(graphqlOperation(sortedlistApplications,{
          Type: 'Application',
          limit: 500,
          sortDirection: 'DESC'
        })),
        API.graphql(graphqlOperation(sortedlistApplications,{
          Type: 'Quote',
          limit: 500,
          sortDirection: 'DESC'
        }))
      ])
      
      // 結果を結合してsortKeyで降順ソート
      const allApplications = [
        ...appResult.data.sortedlistApplications.items,
        ...quoteResult.data.sortedlistApplications.items
      ]
      
      this.applications = allApplications
        .sort((a, b) => new Date(b.sortKey || b.createdAt) - new Date(a.sortKey || a.createdAt))
        .slice(0, 500);
      
      console.log('applications: ', this.applications)
      this.loading = false
    },
    selectApplication: async function(data) {
      console.log("Click Application", data)
      this.$refs.isLoading.start();
      let selectCompany = data.OfficeID.substr(0,10)
      let selectOffice = data.OfficeID
      if(selectCompany != this.$store.state.operatingOffice.CompanyID) {
        let company = await API.graphql(graphqlOperation(companyByKey, {CompanyID: selectCompany}))
        let operatingcompany = company.data.companyByKey.items[0]
        this.$store.commit('setOperatingCompany',operatingcompany )
      }

      let office = await API.graphql(graphqlOperation(officeByKey, {OfficeID: selectOffice}))
      let operatingOffice = office.data.officeByKey.items[0]
      operatingOffice["CompanyName"] = this.$store.state.operatingCompany.Name
      operatingOffice["PaymentOfficeID"] = this.$store.state.operatingCompany.PaymentOfficeID
      this.$store.commit('setOperatingOffice',operatingOffice )

      this.$store.commit('setInitializedAnalize', false )
      this.initAnalizeInfoCore()

      this.progressMessages.splice( 0, 1, {"status":1, "message":"事業所の切り替え"});

      if((data.Type == "Quote") && (data.Status == "quoteRequest")){
        await this.$router.push("/quote?id=" + data.id)
      }else if(data.Type == "Quote"){
        await this.$router.push("/referquote?id=" + data.id)
      }else {
        await this.$router.push("/referapplication?id=" + data.id)
      }
//      this.$refs.isLoading.end();
    }

  },
}
</script>

<style lang="scss" scoped>
  .v-chip .v-chip__content {
    -moz-text-align-last: justify;
    text-align-last: justify;
  }

</style>